import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './KanbanView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: KanbanView,
    },
  ],
};